import logo_light from "./../assets/logo_light.png";

import React, {useState} from "react";
import Hamburger from 'hamburger-react'
import {Link, useLocation} from "@tanstack/react-router";

const LandingHeader = () => {
    const [isOpen, setOpen] = useState(false);
    const location = useLocation();

    return (
        <div className="Header pt-10 px-10 pb-20 md:pb-6 text-[#e6e1e6]">
            <div className="flex justify-between pb-4">
                <Link to="/"><img src={logo_light} alt="Logo" className={"max-h-[40px]"} /></Link>
                <div className={'absolute rounded-full lg:hidden bg-[#070C25] p-1 px-5 flex gap-1 *:px-3 *:py-4 *:min-w-14 *:inline-block *:text-center'}
                     style={{left: '50%', transform: 'translateX(-50%)'}}>
                    <Link to="/" className={'hover:underline' + (location.pathname === '/' ? ' text-[#EADB2C]' : '')}>Home</Link>
                    <Link to="/pricing/" className={'hover:underline' + (location.pathname === '/pricing/' ? ' text-[#EADB2C]' : '')}>Pricing</Link>
                    <Link to="/blog/" className={'hover:underline' + (location.pathname.startsWith('/blog/') ? ' text-[#EADB2C]' : '')}>Blog</Link>
                    <Link to="/faq/" className={'hover:underline' + (location.pathname.startsWith('/faq/') ? ' text-[#EADB2C]' : '')}>Faq</Link>
                    <Link to="/about/" className={'hover:underline' + (location.pathname === '/about/' ? ' text-[#EADB2C]' : '')}>About Us</Link>
                    <Link to="/contact/" className={'hover:underline' + (location.pathname === '/contact/' ? ' text-[#EADB2C]' : '')}>Contact</Link>
                </div>
                <Link to="/login/" className={'inline-flex items-center bg-[#EADB2C] lg:hidden text-black rounded-full px-5 py-0.5 leading-6'}>Login / Signup</Link>
                <div className="hidden lg:block">
                    <Hamburger toggled={isOpen} toggle={setOpen} />
                </div>
            </div>

            {isOpen && <div>
                <div className={'hidden lg:flex flex-col rounded-b--r-css mx-2! bg-[#252525] p-5 px-9 gap-1 *:p-4'}
                >
                    <Link to="/" className={'hover:underline' + (location.pathname === '/' ? ' text-[#EADB2C]' : '')}>Home</Link>
                    <Link to="/pricing/" className={'hover:underline' + (location.pathname === '/pricing/' ? ' text-[#EADB2C]' : '')}>Pricing</Link>
                    <Link to="/blog/" className={'hover:underline' + (location.pathname.startsWith('/blog/') ? ' text-[#EADB2C]' : '')}>Blog</Link>
                    <Link to="/faq/" className={'hover:underline' + (location.pathname.startsWith('/faq/') ? ' text-[#EADB2C]' : '')}>FAQ</Link>
                    <Link to="/about/" className={'hover:underline' + (location.pathname === '/about/' ? ' text-[#EADB2C]' : '')}>About</Link>
                    <Link to="/contact/" className={'hover:underline' + (location.pathname === '/contact/' ? ' text-[#EADB2C]' : '')}>Contact Us</Link>
                    <Link to="/login/" className={'bg-[#EADB2C] text-black rounded-full'}>Login / Signup</Link>
                </div>
            </div>}
        </div>
    );
};

export default LandingHeader;
